<template>
  <link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet'>
  <div class="app">
      <HeaderMenu>  </HeaderMenu>
      <div class="view-container">
          <router-view/>
      </div>
  </div>
</template>

<script>
  import HeaderMenu from "./components/Header_Menu.vue";

  export default {
  data() {
      return {
      }
  },
    name: 'App',
    components: {
        HeaderMenu,
    },
    async mounted() {

    },
    methods: {
    }
    }
  </script>

<style>
html, body {
  margin: 0;
  padding: 0;
}
  
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
  font-family: 'Montserrat', sans-serif;
  text-align: left;
  color: #051d3a;
}

.h1 {
  font-size: 2.7rem;
  font-weight: 500;
  line-height: 1.2em;
}

.p1 {
  font-size: 18px;
  font-weight: 300;
  line-height: 150%;
}

</style>
